<template>
  <div class="login" dir="rtl">
    <div class="square"></div>
    <div class="login-card-outer" ref="form">

      <div class="login-card">
        <img src="/img/login_logo.svg">
        <p style="margin-top: 30px">{{ $t('samaneKhadamat') }}</p>
        <div class="relative" style="margin-top: 30px">
          <v-text-field
            ref="mobile"
            :label="$t('YourNumber')"
            v-model="mobile"
            dense
            :disabled="level!=0"
            :rules="[() => !!mobile || this.$t('necessary'),
              () => {
                  const pattern = /^(\+98|0098|98|0)?9\d{9}$/
                  return pattern.test(persian_to_english(mobile)) || this.$t('phoneNotCorrect')
                }
              ]"
            outlined
            required
          ></v-text-field>
          <!--            :rules="[rules.required, rules.mobile]"-->
        </div>
        <div class="relative" v-if="level==1 && !mobile_exist">
          <v-text-field v-if="$i18n.locale=='fa'"
                        ref="fullName"
                        :label="$t('nameLastName')"
                        dense

                        v-model="fullName"
                        :rules="[
                () => !!fullName || this.$t('necessary'),
                 () => fullName.length <= 30 || this.$t('max30Character'),
                () => {
                  const pattern = /^[پچجحخهعغآ؟.،آفقثصضشسیبلاتنمکگوئدذرزطظژ!!ؤإأءًٌٍَُِّ\s]+$/
                  return pattern.test(fullName) || this.$t('nameNotFarsi')
                },

              ]"
                        outlined
                        required
          ></v-text-field>
          <v-text-field v-if="$i18n.locale!='fa'"
                        ref="fullName"
                        :label="$t('nameLastName')"
                        v-model="fullName"
                        outlined
                        dense
                        required
          ></v-text-field>

        </div>
        <div class="relative" v-if="level==2">

          <v-text-field
            :label="$t('smsCode')"
            v-model="password"
            dense

            :rules="[rules.required]"
            outlined
          ></v-text-field>
        </div>
        <div>
          <button class="btn login-btn-gradient" v-on:click="login()" :disabled="!valid">
            {{ $t('signIn') }}
          </button>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
  /* eslint-disable */

  import {bus} from "../../main";

  export default {
    data() {
      return {
        errors: [],
        mobile: '',
        fullName: '',
        password: '',
        valid: true,
        mobile_exist: false,
        level: 0,

        formHasErrors: false,
      }
    },
    mounted() {
    console.log("next url is",this.$route.query.nextUrl)
      },
    computed: {
      form() {
        return {

          mobile: this.mobile,
          fullName: this.fullName,
          // city: this.city,
          // state: this.state,
          // zip: this.zip,
          // country: this.country,
        }
      },
    },
    methods: {
      rules: {
        required: value => !!value || this.$t('necessary'),
        fullName: value => value.length <= 30 || this.$t('max30Character'),

        mobile: value => {
          const pattern = /^(\+98|0098|98|0)?9\d{9}$/
          return pattern.test(this.persian_to_english(value)) || this.$t('phoneNotCorrect')
        },
      },
      login() {

        // this.rules.required();
        var self = this;
        if (this.level == 0) {
          this.mobile=this.persian_to_english(this.mobile)
          if (!this.persian_to_english(this.mobile).startsWith('09') || this.persian_to_english(this.mobile).length != 11) {
            bus.$emit('show_toast', [2000, this.$t('enterNumberCorrect')])
            return
          }
          const send_data = {
            "Phone": this.persian_to_english(this.mobile),
            "Name": this.fullName
          };
          // this.axios.post('/Register' , send_data,{
          this.axios.post('/CheckExistsMobileNo', send_data, {})
            .then(response => {
              if (response.data.error == 0) {
                self.level = 1;
                self.fullName = response.data.msg;
                self.mobile_exist=true;

                setTimeout(() => {

                  self.login()
                }, 200);

              } else {
                self.level = 1;
                // self.name = response.msg;
              }

            }).catch(e => {
            this.errors.push(e);

          })
        } else if (this.level == 1) {
          this.formHasErrors = false
          var k = 2;

          // Object.keys(this.form).forEach(f => {
          //   if (!this.form[f]) {
          //     this.formHasErrors = true
          //   }
          //   // this.$refs[f].validate(true)
          //   if (this.$refs[f].validate() == true) {
          //     k = k + 1;
          //   }
          // })
          if (k == 2) {
            const send_data = {
              "Phone": this.persian_to_english(this.mobile),
              "Name": this.fullName
            };
            // this.axios.post('/Register' , send_data,{
            this.axios.post('/Register', send_data, {})
              .then(response => {
                if (response.data.error == 0) {
                  console.log("response", response);

                  self.level = 2;
                }
                // this.$router.push({ path: "/post-login", params: {} });

              }).catch(e => {
              this.errors.push(e);

            })
          }

        } else if (this.level == 2) {
          // this.$refs.form.validate();
          var eddited_mobile = self.mobile.substring(1);
          eddited_mobile = "+98" + self.persian_to_english(eddited_mobile);
          if (this.mobile != '' && this.fullName != '') {

            const send_data = {
              "Phone": eddited_mobile,
              "Password": this.password,
              "OsName": "UserPwA",
              "AppNo": "5",
              "OsVersion": "5",
              "DeviceModel": "android",
              "Name": this.fullName,
            };

            // this.axios.post('/Register' , send_data,{
            this.axios.post('/Activate', send_data, {})
              .then(response => {
                if (response.data.error == 0) {
                  console.log("response login", response);

                  localStorage.setItem("profile", JSON.stringify(response.data.profile))
                  localStorage.setItem("phone", eddited_mobile)
                  localStorage.setItem("password", self.password)
                  if(self.$route.query.nextUrl==null){
                    self.$router.push({path: "/home-tab", params: {}});

                  }else{
                    self.$router.push({path: self.$route.query.nextUrl, params: {}});

                  }

                  // self.$router.push({ path: "/post-login", params: {} });

                }else{
                  bus.$emit('show_toast', [2000,response.data.msg ])

                }

              }).catch(e => {
              this.errors.push(e);

            })
          }


        }

      },

    }
  }
</script>
